import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../index.css";

const initialData = [
  { id: 1, name: "Cash", desc: "Cash", status: "Inactive" },
  { id: 2, name: "Card", desc: "Card", status: "Inactive" },
];

export default function PayMode() {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [selected, setSelected] = useState(null);
  const [search, setSearch] = useState("");

  //  Load from localStorage with fallback
  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("paymode"));

    if (saved && saved.length > 0) {
      setList(saved);
    } else {
      setList(initialData);
      localStorage.setItem("paymode", JSON.stringify(initialData));
    }
  }, []);

  //  Refresh when coming back from form
  useEffect(() => {
    const handleFocus = () => {
      const saved = JSON.parse(localStorage.getItem("paymode")) || [];
      setList(saved);
    };

    window.addEventListener("focus", handleFocus);
    return () => window.removeEventListener("focus", handleFocus);
  }, []);

  //  Filter
  const filtered = list.filter((item) =>
    (item.name || "").toLowerCase().includes(search.toLowerCase())
  );

  //  Delete
  const handleDelete = () => {
    if (!selected) return alert("Select row first");

    const updated = list.filter((l) => l.id !== selected.id);

    setList(updated);
    localStorage.setItem("paymode", JSON.stringify(updated));
    setSelected(null);
  };

  return (
    <>
      <style>{`
        .page {
          background: #f5f7fb;
          padding: 20px;
        }

        .card {
          background: #fff;
          padding: 20px;
          border-radius: 10px;
          border: 1px solid #e5e7eb;
        }

        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
        }

        .header h3 {
          margin: 0;
          font-weight: 600;
        }

        .controls {
          display: flex;
          gap: 10px;
          margin-bottom: 15px;
          align-items: center;
        }

        .search-box {
          padding: 8px 10px;
          border: 1px solid #d1d5db;
          border-radius: 6px;
          width: 220px;
        }

        .btn {
          padding: 7px 14px;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          font-weight: 500;
        }

        .btn-dark {
          background: #2c3e50;
          color: #fff;
        }

        .btn-blue {
          background: #3498db;
          color: #fff;
        }

        .btn-red {
          background: #e74c3c;
          color: #fff;
        }

        table {
          width: 100%;
          border-collapse: collapse;
        }

        th {
          text-align: left;
          padding: 12px 10px;
          font-weight: 600;
          color: #374151;
          border-bottom: 1px solid #e5e7eb;
        }

        td {
          padding: 12px 10px;
          border-bottom: 1px solid #f0f0f0;
        }

        tr:hover {
          background: #f9fafb;
        }

        .active-row {
          background: #eef3ff;
        }

        input[type="checkbox"] {
          cursor: pointer;
        }
      `}</style>

      <div className="page">
        <div className="card">

          {/* HEADER */}
          <div className="header">
            <h3>Pay Mode</h3>
            <div>{list.length} Records</div>
          </div>

          {/* CONTROLS */}
          <div className="controls">
            <input
              className="search-box"
              placeholder="Search Paymode"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            <button
              className="btn btn-dark"
              onClick={() => navigate("/admin/paymode/add")}
            >
              + Add
            </button>

            <button
              className="btn btn-blue"
              onClick={() => {
                if (!selected) return alert("Select row first");
                navigate(`/admin/paymode/edit/${selected.id}`);
              }}
            >
              Update
            </button>

            <button className="btn btn-red" onClick={handleDelete}>
              Delete
            </button>
          </div>

          {/* TABLE */}
          <table>
            <thead>
              <tr>
                <th style={{ width: "40px" }}></th>
                <th>Paymode Name</th>
                <th>Paymode Desc</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {filtered.map((item) => (
                <tr
                  key={item.id}
                  className={selected?.id === item.id ? "active-row" : ""}
                  onClick={() => setSelected(item)}
                >
                  <td>
                    <input
                      type="checkbox"
                      checked={selected?.id === item.id}
                      onChange={() => setSelected(item)}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </td>

                  <td>{item.name}</td>
                  <td>{item.desc}</td>
                  <td>{item.status}</td>
                </tr>
              ))}
            </tbody>
          </table>

        </div>
      </div>
    </>
  );
}